import { render, staticRenderFns } from "./statistic-chart.vue?vue&type=template&id=9b664efc&scoped=true"
import script from "./statistic-chart.vue?vue&type=script&lang=js"
export * from "./statistic-chart.vue?vue&type=script&lang=js"
import style0 from "./statistic-chart.vue?vue&type=style&index=0&id=9b664efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b664efc",
  null
  
)

export default component.exports